module.exports = __webpack_public_path__ + "static/media/IC_data_upload.3c452104.svg";